import { render, staticRenderFns } from "./RestrictedIpModify.vue?vue&type=template&id=648609ca"
import script from "@/scripts/modal/systemManager/restrictedIp/restrictedIpModify.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/systemManager/restrictedIp/restrictedIpModify.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports